export default () => import(/* webpackChunkName: 'coffee/activities/membership/rules' */ './Rules');
